import { Box, Typography } from '@mui/material';
import { getIcon } from './icons';

function BenefitsList({ benefits }) {
  if (!benefits?.length) return null;

  return (
    <Box
      sx={{
        mx: 'auto',
        maxWidth: 560,
        mb: { xs: 5, sm: 7, md: 9 },
      }}
    >
      <Typography
        variant="overline"
        sx={{
          display: 'block',
          color: 'primary.main',
          letterSpacing: '0.22em',
          fontWeight: 600,
          fontSize: '0.72rem',
          mb: 2,
          textAlign: 'center',
        }}
      >
        Impacto
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {benefits.map((benefit, i) => {
          const Icon = getIcon(benefit.icon);
          return (
            <Box
              key={i}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                p: 1.5,
                borderRadius: 2,
                backgroundColor: 'rgba(255, 255, 255, 0.55)',
                border: '1px solid rgba(74, 106, 74, 0.12)',
              }}
            >
              <Icon size={20} color="#4a6a4a" strokeWidth={1.75} />
              <Typography
                sx={{
                  color: 'text.primary',
                  fontSize: { xs: '0.95rem', sm: '1rem' },
                  lineHeight: 1.4,
                }}
              >
                {benefit.text}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default BenefitsList;
